import type { ClientSurface } from '@/convex/products/ai/lib/client_surface.helpers';

/** What the browser can tell about where the user is sending from. */
export type BrowserSurfaceSignals = {
  width: number;
  coarsePointer: boolean;
  desktopApp: boolean;
};

/**
 * The surface a web or Electron send reports. The chat docks its side panel
 * at 1024px and up on a fine pointer (useArtifactDrawerLayout); below that,
 * files open in a sheet over the chat.
 */
export function clientSurfaceFromSignals(
  signals: BrowserSurfaceSignals
): ClientSurface {
  const viewport =
    signals.width < 768 ? 'phone' : signals.width < 1024 ? 'tablet' : 'desktop';
  const kind = signals.desktopApp
    ? 'desktop_app'
    : viewport === 'phone' || signals.coarsePointer
      ? 'mobile_web'
      : 'desktop_web';
  return {
    kind,
    viewport,
    sidePanel: signals.width >= 1024 && !signals.coarsePointer,
  };
}

/** Read at send time; undefined outside a browser. */
export function readBrowserClientSurface(): ClientSurface | undefined {
  if (typeof window === 'undefined') return undefined;
  return clientSurfaceFromSignals({
    width: window.innerWidth,
    // Same touch-primary test as useTouchPrimary.
    coarsePointer:
      ('ontouchstart' in window || navigator.maxTouchPoints > 0) &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(pointer: coarse)').matches,
    desktopApp: 'imaiDesktop' in window,
  });
}
